import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Button, IconBackground } from "./IconButton.styles";
var IconButton = function(_param) /*#__PURE__*/ {
    var id = _param.id, Icon = _param.icon, title = _param.title, className = _param.className, onClick = _param.onClick, _size = _param.size, size = _size === void 0 ? "medium" : _size, _selected = _param.selected, selected = _selected === void 0 ? false : _selected, rest = _object_without_properties(_param, [
        "id",
        "icon",
        "title",
        "className",
        "onClick",
        "size",
        "selected"
    ]);
    return _jsx(Button, _object_spread_props(_object_spread({
        id: id,
        type: "button",
        size: size,
        title: title,
        className: className,
        onClick: onClick
    }, rest), {
        children: /*#__PURE__*/ _jsx(IconBackground, {
            id: "".concat(id, "-bg"),
            selected: selected,
            children: /*#__PURE__*/ _jsx(Icon, {
                id: "".concat(id, "-icon"),
                width: "100%",
                height: "100%"
            })
        })
    }));
};
export { IconButton };
